import React from 'react';
import { FaUser, FaBuilding } from 'react-icons/fa';

const ChooseUserType = () => {
  return (
    <div className="min-h-[60vh] mt-20 mb-32 px-4 max-w-5xl mx-auto flex flex-col justify-center text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-6">Choose User Type</h2>
      <p className="text-gray-600 mb-10 text-sm md:text-base">
        Select whether you're hosting the contest as an individual or an organization.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Individual */}
        <div
          className="cursor-pointer border border-gray-300 rounded-2xl p-6 shadow hover:shadow-lg transition-all hover:border-blue-500 hover:bg-blue-50 group"
        >
          <div className="flex flex-col items-center space-y-4">
            <FaUser size={40} className="text-blue-500 group-hover:scale-110 transition-transform" />
            <h3 className="text-xl font-semibold">Individual</h3>
            <p className="text-gray-600 text-sm text-center">
              Ideal for students, freelancers, or solo developers hosting a contest.
            </p>
          </div>
        </div>

        {/* Organization */}
        <div
          className="cursor-pointer border border-gray-300 rounded-2xl p-6 shadow hover:shadow-lg transition-all hover:border-green-500 hover:bg-green-50 group"
        >
          <div className="flex flex-col items-center space-y-4">
            <FaBuilding size={40} className="text-green-500 group-hover:scale-110 transition-transform" />
            <h3 className="text-xl font-semibold">Organization</h3>
            <p className="text-gray-600 text-sm text-center">
              Perfect for colleges, companies, or communities looking to conduct contests.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUserType;
